import {colors, radii} from '@commercial-helios/ui/theme'
import React from 'react'
import styled, {css} from 'styled-components'

import playBtnIcon from '@/images/icons/play-btn.svg'
import {useGlobalStrings} from '@helios/shared/providers/global-strings'

type Props = React.HTMLProps<HTMLButtonElement>

const Button = React.forwardRef<HTMLButtonElement, Props>(
    ({as: ButtonComponent = 'button', ...props}, ref) => {
        const globalStrings = useGlobalStrings()
        return <ButtonComponent aria-label={globalStrings.playVideo} ref={ref} {...props} />
    },
)

export const playIconStyles = css`
    background-image: url(${playBtnIcon});
    background-repeat: no-repeat;
    background-position: center;
    border-radius: ${radii.circle};
`

const PlayButton = styled(Button)<Props>`
    display: block;
    width: 40px;
    height: 40px;
    padding: 0;
    cursor: pointer;
    border: 1px solid ${colors.border.inverted};
    background-color: ${colors.button.default.background};
    ${playIconStyles};

    &:hover {
        background-color: ${colors.button.default.hover.background};
    }

    &:focus {
        border-color: ${colors.focusRing};
    }

    &:disabled {
        opacity: 0.25;
    }
`

export default PlayButton
